<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{ $t("btn.qualityData.receive") }}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <li class="breadcrumb-item">
              <span>{{$t('btn.qualityData.receive')}}</span>
          </li>
        </ul>
      </div>
    </div>
    <section class="app-content">
      <div class="card">
        <div class="card-body">
          <form>
            <div class="row">
              <div class="form-group col-md-2">
                <label class="control-label">{{$t('lbl.qualityPlan.planCode')}}:</label>
                <input class="form-control" type="text" v-model="planCodeFilter" />
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">{{$t('lbl.qualityPlan.planDate')}}:</label>
                <input class="form-control" type="date" v-model="planDateStrFilter" />
              </div>

              <div class="form-group col-md-2">
                <label class="control-label">{{$t('lbl.qualityPlan.planPlant')}}:</label>
                <select class="form-control" v-model="plantFilter">
                    <option value="default">{{$t("lbl.basic.select.one")}}</option>
                    <option value="球团车间一期">{{$t('lbl.basic.plant.pelletizing1')}}</option>
                    <option value="球团车间二期">{{$t('lbl.basic.plant.pelletizing2')}}</option>
                    <option value="球团车间三期">{{$t('lbl.basic.plant.pelletizing3')}}</option>
                    <option value="冶炼车间一期">{{$t('lbl.basic.plant.smelting1')}}</option>
                    <option value="冶炼车间二期">{{$t('lbl.basic.plant.smelting2')}}</option>
                    <option value="冶炼车间三期">{{$t('lbl.basic.plant.smelting3')}}</option>
                  </select>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">{{$t('lbl.qualityPlan.planShift')}}:</label>
                <select class="form-control" type="text" v-model="shiftFilter">
                    <option value>{{ $t("lbl.basic.select.one") }}</option>
                    <option value="甲">{{ $t("lbl.qualityPlan.shiftA") }}</option>
                    <option value="乙">{{ $t("lbl.qualityPlan.shiftB") }}</option>
                    <option value="丙">{{ $t("lbl.qualityPlan.shiftC") }}</option>
                  </select>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">{{$t('lbl.qualityPlan.itemName')}}:</label>
                <input class="form-control" type="text" v-model="itemNameFilter" />
              </div>
            </div>
            <div class="col-lg-12 align-self-end">
              <div class="float-lg-right">
                <button
                  class="btn btn-outline-secondary mr-1"
                  type="button"
                  v-on:click="MMFClearFilter('qualityData')"
                >
                  <i class="fa fa-fw fa-lg fa-eraser"></i>
                  <span class="text">{{ $t("btn.basic.clear") }}</span>
                </button>
                <button class="btn btn-primary" type="button" v-on:click="loadRows()">
                  <i class="fa fa-fw fa-lg fa-search"></i>
                  <span class="text">{{ $t("btn.basic.search") }}</span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div id="qualityDataTable" class="content">
        <div class="card my-1">
          <div
            id="collapseTwo"
            class="collapse show"
            aria-labelledby="headingTwo"
            data-parent="#accordionResult"
          >
            <div class="card-body">
              <div class="bs-component"></div>
              <mmf-table
                entity="qualityData"
                inline-actions-disabled
                :singleChoice="true"
                disableEdit
                disableDelete
              >
                <div slot="btnList" class="btn-group" slot-scope="slotProps">
                  <b-button
                    v-b-modal.modal-1
                    variant="outline-primary"
                    :disabled="slotProps.checkedLength!=1"
                  >
                    <i class="fa fa-pencil-alt" aria-hidden="true"></i>
                    <span class="text">{{$t('btn.qualityData.receive')}}</span>
                  </b-button>
                  <!-- <button
                    :disabled="slotProps.checkedLength!=1"
                    v-bind:class="'btn btn-outline-primary btn-sm'"
                    v-on:click="Details(entity)"
                  >
                    <i class="fa fa-cog" aria-hidden="true"></i>
                    <span class="text">{{ $t("btn.qualityData.details") }}</span>
                  </button> -->
                </div>
              </mmf-table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <b-modal id="modal-1" 
      :title="$t('btn.qualityData.receive')" 
      ok-title="确认接收" 
      cancel-title="取消" 
      @ok="receive('qualityData')">
      <b-container fluid>
        <b-row class="mb-1 text-center">
          <b-col>{{$t('lbl.qualityData.person')}}</b-col>
          <!-- <b-col>{{$t('lbl.qualityData.time')}}</b-col> -->
        </b-row>
        <b-row class="mb-2">
          <b-col>
            <input class="form-control" type="text" v-model="person" />
          </b-col>
          <!-- <b-col>
            <mmf-datetimepicker v-model="time"></mmf-datetimepicker>
          </b-col>-->
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import {
  gridFields,
  filterFields
} from "@/model/prd/qualityMgt/pelletizing/QualityData";
import { fields } from "@/model/prd/qualityMgt/pelletizing/QualityData";
import MmfTable from "@/components/MmfTable";
// import MmfDatetimepicker from "@/components/MmfDatetimepicker";

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
  getterType: "qualityData/getField",
  mutationType: "qualityData/updateField"
});

export default {
  name: "qualityDataList",
  data() {
    return {
      person: "",
      checkedItems: [],
    };
  },
  components: { MmfTable },
  computed: {
    // generate and add getters and setters using the filter names defined in
    // entity model

    ...mapFields(fields),
    ...mapFields(filterFields),
    ...mapState({
      rows: state => state.qualityData.rows,
      tableColumns: gridFields,
      entity: state => state.qualityData.entity,
      qualityResultEntity: state => state.qualityResult.entity,
      qualityPlanStatus: state => state.qualityData.qualityPlanStatus,
      baseModuleUrl: state => state.qualityData.baseModuleUrl
    })
  },
  methods: {
    ...mapActions("qualityData", ["ReceiveSample"]),
    ...mapActions("qualityResult", ["Check"]),
     ...mapActions("base", ["MMFselectRow", "MMFselectAllRows", "MMFNew", 
    "MMFEdit", "MMFLoadRows", "MMFDelete", "MMFClearFilter"]),
    receive(moudle) {
      this.entity.checkPerson = this.person;
      var me = this;
      me.ReceiveSample(moudle).then(function(){
        me.loadRows();
      });
      this.clear();
    },
    clear() {
      this.person = "";
    },
    loadRows(){
       this.planDateStrFilter = null;
       this.statusFilter="N";
       this.MMFLoadRows('qualityData');
    }
  },
  mounted(){
      this.loadRows()
  }
    
  // created() {

  //   const context = this.$store;
  //   // const id = this.$route.query.id; // 从当前的路由中获取参数 id
  //   const baseModuleUrl = this.baseModuleUrl;

  //   context
  //     .dispatch("api/get", {
  //       url:
  //         baseModuleUrl +
  //         "/qualityPlan/findById/" +
  //         id
  //     })
  //     .then(response => {
  //       context.commit("qualityData" + "/setRows", response.qualityDatas);
  //       context.dispatch("qualityData/qualityPlanStatus", response);
  //     });
  //     this.clear();
  // }
};
</script>
